<template>
  <div
    class="cp-speaker-card"
    :class="{'-active' : isActive}"
    v-click-outside="hideActive"
  >
    <div class="-container">
      <div
        class="icon-mobile"
        @click="toggleActive"
      >
        <svg class="icon icon-eye-speaker-card">
          <use xlink:href="#icon-eye-speaker-card"></use>
        </svg>
      </div>
      <img
        loading="lazy"
        width="453"
        height="570"
        :src="item.image"
        :alt="item.speakerName"
      >
      <div class="-hover-block">
        <div
          class="-content"
          @click="toggleActive"
        >
          <div class="-name">
            {{ item.speakerName }}
          </div>
          <div class="-job">
            {{ item.job }}
          </div>
          <div
            v-if="item.eventLinks.length"
            class="-events"
          >
            <template v-for="(event, index) in item.eventLinks">
              <a
                :href="event.url"
                :key="index"
                v-if="event.url.length > 0"
              >{{ event.label }}
                <svg class="icon icon-speaker-card-link">
                  <use xlink:href="#icon-speaker-card-link"></use>
                </svg>
              </a>
              <span
                :key="index"
                v-else
              >{{ event.label }} </span>
            </template>
          </div>
          <perfect-scrollbar
            ref="ps"
            :options="scrollOptions"
          >
            <div
              v-if="item.description !== ''"
              class="-description"
              v-html="item.description"
            />
          </perfect-scrollbar>
          <div
            v-if="item.socialLinks"
            class="-socials"
          >
            <a
              v-for="(social, index) in item.socialLinks"
              :key="index"
              :href="social.url"
              target="_blank"
              rel="noopener"
            >
              <svg :class="`icon icon-${social.platform}`">
                <use :xlink:href="`#icon-${social.platform}`"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="-bottom">
      <h2 class="-name">
        {{ item.speakerName }}
      </h2>
      <div class="-job">
        {{ item.job }}
      </div>
    </div>
  </div>
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.esm';
import ClickOutside from 'vue-click-outside';

export default {
  directives: {
    ClickOutside,
  },
  components: {
    PerfectScrollbar,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      scrollOptions: {
        suppressScrollX: true,
      },
      isActive: false,
    };
  },
  created() {
    window.addEventListener('resize', this.updatePs);
  },
  methods: {
    updatePs() {
      this.$refs.ps.update();
    },
    toggleActive() {
      this.isActive = !this.isActive
    },
    hideActive() {
      this.isActive = false;
    },
  },
};
</script>

<style scoped>
</style>
